import { render, staticRenderFns } from "./Accept.vue?vue&type=template&id=e04433aa&scoped=true&"
import script from "./Accept.vue?vue&type=script&lang=js&"
export * from "./Accept.vue?vue&type=script&lang=js&"
import style0 from "./Accept.vue?vue&type=style&index=0&id=e04433aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04433aa",
  null
  
)

export default component.exports